import { UserRole } from "src/app/@types/enums/user.roles";
import { authDataService } from "src/app/services/data/auth.data.service";

// Helper function to determine which banner image to show based on user role
export const getBannerImage = (): string => {
  switch (authDataService.userRoleId) {
    case UserRole.Youth:
      return "assets/images/demo-content/home-banner-youth.png";
    case UserRole.Host:
      return "assets/images/demo-content/home-banner-host.png";
    case UserRole.Admin:
      return "assets/images/demo-content/home-banner-admin.png";
    case UserRole.Parent:
      return "assets/images/demo-content/home-banner-parent.png";
    default:
      return "assets/images/demo-content/home-banner-youth.png";
  }
};
